import { createSelector } from 'reselect';
import precise from '../modules/precise';

const plateFeeSel = state => state.registration.plateFee;
const mobileHomeLengthSel = state => state.mobilehome.mobileHomeLength;

const plateFeeSelector = createSelector(
  [plateFeeSel, mobileHomeLengthSel],
  (plateFee, mobileHomeLength) => {
    return precise(Number(plateFee) * mobileHomeLength);
  },
);

export default plateFeeSelector;
